import {arrayMove} from '@dnd-kit/sortable';

import {RelativeFilterResponseBody} from '../../../../../types/api/api';

export function reorderPresetsInList(
  orderedPresets: RelativeFilterResponseBody[],
  activeId: string,
  overId: string
): RelativeFilterResponseBody[] {
  const sortablePresets = orderedPresets.filter((preset) => !preset.default);
  const oldIndex = sortablePresets.findIndex((preset) => preset.id === activeId);
  const newIndex = sortablePresets.findIndex((preset) => preset.id === overId);

  if (oldIndex === -1 || newIndex === -1) {
    return orderedPresets;
  }

  const reorderedSortable = arrayMove(sortablePresets, oldIndex, newIndex);

  let sortableIndex = 0;

  return orderedPresets.map((preset) =>
    preset.default ? preset : reorderedSortable[sortableIndex++]
  );
}
